<template>
  <CModal
      :show.sync="visible"
      :close-on-backdrop="false"
      size="lg"
  >
    <template #header>
      <h5 class="modal-title">
        <translate translate-context="email_templates.debug_logs">Bulk Send Emails</translate>
      </h5>
      <CButton
          class="close"
          @click="close"
      >
        <span>&times;</span>
      </CButton>
    </template>

    <div>
      <p class="text-muted">
        <translate translate-context="email_templates.debug_logs">
          Paste email addresses separated by comma (,), semicolon (;), or newline. Emails will be sent and logged.
        </translate>
      </p>
      <CTextarea
          v-model="emailsText"
          :placeholder="$pgettext('email_templates.debug_logs', 'email1@example.com, email2@example.com\nemail3@example.com')"
          rows="8"
          class="mb-3"
      />
      <div class="d-flex align-items-center">
        <input
            id="sendOnlyPendingBulk"
            v-model="sendOnlyPending"
            type="checkbox"
            class="mr-2"
        />
        <label for="sendOnlyPendingBulk" class="mb-0">
          <translate translate-context="email_templates.debug_logs">
            Send only pending
          </translate>
        </label>
      </div>
      <p class="text-muted small mt-2 mb-0">
        <translate translate-context="email_templates.debug_logs">
          Only send to recipients who haven't received the email yet
        </translate>
      </p>
    </div>

    <template #footer>
      <CButton
          color="secondary"
          @click="close"
      >
        <translate translate-context="email_templates.debug_logs">Cancel</translate>
      </CButton>
      <CButton
          color="primary"
          @click="handleSend"
          :disabled="!emailsText.trim()"
      >
        <CIcon name="cilPaperPlane" class="mr-2"/>
        <translate translate-context="email_templates.debug_logs">Send Bulk Emails</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'BulkSendModal',

  data() {
    return {
      visible: false,
      emailsText: '',
      sendOnlyPending: true
    }
  },

  methods: {
    open() {
      this.emailsText = ''
      this.sendOnlyPending = true
      this.visible = true
    },

    close() {
      this.visible = false
    },

    parseEmailAddresses(text) {
      if (!text) return []

      // Split by comma, semicolon, or newline
      const emails = text
          .split(/[,;\n]/)
          .map(email => email.trim())
          .filter(email => email.length > 0)

      return emails
    },

    handleSend() {
      const emailAddresses = this.parseEmailAddresses(this.emailsText)

      if (emailAddresses.length === 0) {
        this.notifyError(
            this.$pgettext('email_templates.debug_logs', 'Please enter at least one email address')
        )
        return
      }

      this.$emit('send', {
        emailAddresses,
        sendOnlyPending: this.sendOnlyPending
      })

      this.close()
    }
  }
}
</script>
